import { mapActions} from 'vuex'
export const uploadCopyRight = {
    data() {
        return {
			rowObj: {},
            uploadVisible: false,
            submitParams: {
                url: ''
            }
        }
    },
    methods: {
        ...mapActions('createClass', ['uprightsdesc']),
        uploads(row) {
            this.rowObj = row
            this.submitParams.url = row.rights_img
            this.submitParams.id = row.id
            this.uploadVisible = true
        },
        downLoadTemplate() {
            let baseURL= ''
            if(process.env.VUE_APP_GRALIC === 'development') {
                baseURL = 'http://wisdom.fat.doutuimao.net'
            } else if(process.env.VUE_APP_GRALIC === 'test') {
                baseURL = 'http://wisdom.fat.doutuimao.net'
            } else {
                baseURL = 'http://wisdom.doutuimao.net'
            }
            window.open(baseURL+ '/product/rights/' + this.submitParams.id)
        },
        async submitImg() {
            let res = await this.uprightsdesc(this.submitParams)
            this.$set(this.rowObj, 'rights_img', this.submitParams.url)
            this.uploadVisible = false
            this.$message({
                type: 'success',
                message: '提交成功'
            })
        }
    }
}